export const IMAGE_SEARCHER_PATTERN = /(^image)|(png$)|(jpg$)|(jpeg$)|(svg$)|(webp$)/gi;
